








const ExcelJS = require("exceljs");

import { Component, Watch, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { BPagination } from "bootstrap-vue";
import Header from "@/components/Header.vue";
import EntityTabs from "@/components/EntityTabs.vue";
import App from "@/App.vue";

@Component({
  components: {
    BPagination,
    Header,
    EntityTabs
  },
  computed: {
    ...mapState("gaps", ["filter"]),
  },
})
export default class StatusSummaryReport extends Vue {
  
  header: any = {};
  url:any="";
  pageRows: Array<any> = [];
  @Watch("filter", { deep: true })
  onFilterChanged() {
      this.$store.state.gaps.reportLink="";
  }

  mounted() {

  }
}
